const inventory = document.querySelector(".product product-info .product__inventory")

if (inventory && !inventory.dataset.notifyMeObserved) {
  inventory.dataset.notifyMeObserved = "true"

  const update = () => {
    const isOutOfStock =
      inventory.querySelector(".out-of-stock") && !inventory.classList.contains("hidden")
    document.body.classList.toggle("variant-out-of-stock", !!isOutOfStock)
  }

  update()
  new MutationObserver(update).observe(inventory, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ["class"],
  })
}
